if (customElements.get('component-plans') === undefined) {
    class Plans extends HTMLElement {
        constructor() {
            super();
            this.buttons = this.querySelectorAll('a');
        }
        static get observedAttributes() {
            return [];
        }
        attributeChangedCallback(attr, oldVal, newVal) {
            if (oldVal !== newVal) {
                this[attr] = newVal;
            }
        }
        connectedCallback() {
            this.suscribe();
        }
        async suscribe() {
            this.buttons.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (e.target.getAttribute('data-plan')) {
                        let url = e.target.getAttribute('data-plan');
                        localStorage.setItem('redirect', url);
                        window.location.href = e.target.href;
                    }
                });
            });
        }
    }
    customElements.define('component-plans', Plans);
}
